<template>
  <div>
    <BuyoutItemInfoAbout
        :buyout="buyout"
        :buyout-item="buyoutItem"
        :ccy="ccy"
        :loading="loading"
        :sourceStatuses="sourceStatuses"
    ></BuyoutItemInfoAbout>

    <InvoiceList
        :buyout="buyout"
        :buyout-item="buyoutItem"
        :ccy="ccy"
        :loading="loading"
        :sourceStatuses="sourceStatuses"
    ></InvoiceList>

    <BuyoutItemInfoPickupPoint
        :buyout-item="buyoutItem"
        :loading="loading"
    ></BuyoutItemInfoPickupPoint>

    <BuyoutItemInfoOrderNumber
        :buyout-item="buyoutItem"
        :loading="loading"
        :settings="settings"
    ></BuyoutItemInfoOrderNumber>

    <div
        v-if="hasArchiveAction"
        align="center"
    >
      <v-btn
          v-if="canArchive"
          color="primary"
          text
          :loading="process"
          :disabled="process"
          @click="dialogOpen"
      >
        <v-icon
            class="text--white"
            left
        >
          mdi-eye-off
        </v-icon>
        В архив
      </v-btn>

      <v-btn v-if="canUnarchive"
             color="primary"
             text
             :loading="process"
             :disabled="process"
             @click="unarchiveBuyoutItem">
        <v-icon
            class="text--white"
            left
        >
          mdi-eye
        </v-icon>
        Вернуть в список
      </v-btn>
    </div>

    <v-dialog
        v-model="dialog"
        eager
        persistent
        width="unset"
    >
      <v-card
          elevation="0"
          ref="dialog"
          :class="{'rounded-0': $vuetify.breakpoint.mobile, 'sm': !$vuetify.breakpoint.mobile}"
      >
        <v-card-title class="headline">
          Скрыть закупку?
        </v-card-title>
        <v-card-text v-if="buyout">
          Закупка "{{buyout.title}}" будет перемещена в архив и скрыта из списка закупок. Продолжить?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="dialog = false"
          >
            Отмена
          </v-btn>
          <v-btn
              color="primary"
              text
              @click="archiveBuyoutItem"
          >
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BuyoutItemInfoAbout from '@/components/BuyoutItemInfoAbout'
import BuyoutItemInfoOrderNumber from '@/components/BuyoutItemInfoOrderNumber'
import BuyoutItemInfoPickupPoint from '@/components/BuyoutItemInfoPickupPoint'
import InvoiceList from '@/components/InvoiceList'
import {ccy} from '@/constants'
import {fillDialogPosition} from '@/services/utils'
import Statuses from '@/services/statuses'

export default {
  name: 'BuyoutItemInfo',
  components: {BuyoutItemInfoPickupPoint, BuyoutItemInfoOrderNumber, BuyoutItemInfoAbout, InvoiceList},
  computed: {
    canArchive: function () {
      return this.buyoutItem && this.buyoutItem.canArchive
    },
    canUnarchive: function () {
      return this.buyoutItem && this.buyoutItem.canUnarchive
    },
    ccy: function () {
      return this.buyout ? ccy[this.buyout.buyoutCurrency].sign : ''
    },
    hasArchiveAction: function () {
      return this.buyoutItem && (this.canArchive || this.canUnarchive)
    }
  },
  data () {
    return {
      dialog: false,
      process: false,
      sourceStatuses: null,
    }
  },
  created() {
    Statuses.getSourceStatuses(this.$route.params.sourceId)
      .then((data) => {
        this.sourceStatuses = data;
      });
  },
  methods: {
    dialogOpen (event) {
      fillDialogPosition(event.target, this.$refs.dialog.$el.parentElement)
      this.dialog = true
    },
    toggleArchiveAction () {
      this.buyoutItem.canArchive = !this.buyoutItem.canArchive
      this.buyoutItem.canUnarchive = !this.buyoutItem.canUnarchive
    },
    archiveBuyoutItem () {
      this.dialog = false
      this.process = true
      this.$client.post(`${this.$API.BUYOUTS.BUYOUT_ITEM_ARCHIVE}?id=${this.buyoutItem.id}`).then(() => {
        this.toggleArchiveAction()
        this.process = false
      })
    },
    unarchiveBuyoutItem () {
      this.process = true
      this.$client.post(`${this.$API.BUYOUTS.BUYOUT_ITEM_UNARCHIVE}?id=${this.buyoutItem.id}`).then(() => {
        this.toggleArchiveAction()
        this.process = false
      })
    }
  },
  props: {
    buyout: {
      type: Object
    },
    buyoutItem: {
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    },
    settings: {
      type: Object
    }
  }
}
</script>

<style scoped>
/deep/ .v-subheader {
  background-color: rgb(250,250,250);
  color: rgba(0,0,0,0.54);
  font-weight: 500;
}
</style>